import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getSlackConnection } from 'features/agents/api/agentsApi';
import ConnectionStatus from 'features/agents/WorkflowEditor/fields/ConnectionStatus';

/**
 * Shown on Slack steps in place of a credential picker. When the team's
 * workspace is connected it renders nothing; it only speaks up to ask for a
 * connection, or a reconnect when the mention scope is missing.
 */
export default function SlackWorkspaceStatus() {
  const { team } = useParams();
  const [conn, setConn] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getSlackConnection()
      .then((c) => { if (!cancelled) setConn(c); })
      .catch(() => { if (!cancelled) setConn({ connected: false }); });
    return () => { cancelled = true; };
  }, []);

  const href = `/${encodeURIComponent(team || '')}/settings/org-slack`;

  if (conn === null) return <ConnectionStatus provider="slack" loading title="Checking Slack" />;
  if (!conn.connected) {
    return (
      <ConnectionStatus provider="slack" tone="warning" title="Slack is not connected" action={{ href, label: 'Connect' }}>
        Connect your workspace, then pick a channel below.
      </ConnectionStatus>
    );
  }
  if (conn.needs_reauthorize) {
    return (
      <ConnectionStatus provider="slack" tone="warning" title="Slack needs a new permission" action={{ href, label: 'Reconnect' }}>
        App mention triggers need <span className="font-mono">app_mentions:read</span>.
      </ConnectionStatus>
    );
  }
  return null;
}
